import {Component, EventEmitter, Input, Output, OnChanges, SimpleChanges, ChangeDetectorRef, AfterViewInit} from '@angular/core';
import {SalesConciergeRequest} from '../../../models/sales-concierge-request.model';
import {SalesConciergeCustomerType} from '../../../enums/sales-concierge-customer-type.enum';
import {SalesConciergeStep} from '../../../enums/sales-concierge-step.enum';
import {MyValuesChoicesModel} from '../../../models/my-values-choices.model';

@Component({
    selector: 'sales-concierge-customer-info.',
    templateUrl: './customer-info.component.html',
    styleUrls: ['./customer-info.component.scss']
})
export class SalesConciergeCustomerInfoComponent implements OnChanges, AfterViewInit {


    @Input() public salesConciergeRequest: SalesConciergeRequest;
    public salesConciergeCustomerType = SalesConciergeCustomerType;

    @Input() reset = false;
    @Output() salesConciergeStep = new EventEmitter<SalesConciergeStep>();
    @Output() salesConciergeNextStep = new EventEmitter<SalesConciergeStep>();

    @Output()
    public selectedSalesConciergeRequest: EventEmitter<SalesConciergeRequest> = new EventEmitter<SalesConciergeRequest>();

    public constructor(
        private cd: ChangeDetectorRef,
    ) {
    }


    public selects = {
        'customerTypeSelector': new MyValuesChoicesModel(SalesConciergeCustomerType),
    };


    public ngAfterViewInit() {
        this.cd.detectChanges();
    }


    public onPreviousBtnClicked() {
        this.salesConciergeStep.emit(SalesConciergeStep.PRODUCT_COUNT_INFO);
    }

    public ngOnChanges(change: SimpleChanges) {
        this.salesConciergeNextStep.emit(SalesConciergeStep.CUSTOMER_CONTACT_INFO);
        this.selectedSalesConciergeRequest.emit(this.salesConciergeRequest);
    }


    public getKeyByValue(EnumType: Object, value: any): string {
        return Object.keys(EnumType).find(key => EnumType[key] === value);
    }


    public setCustomerInfoZip(zip: number) {

        this.salesConciergeRequest.customerInfo.zip = zip;
        this.selectedSalesConciergeRequest.emit(this.salesConciergeRequest);
    }

    public setCustomerInfoType(customerType: string) {

        const key = this.getKeyByValue(SalesConciergeCustomerType, customerType);
        this.salesConciergeRequest.customerInfo.customerType = key;
        this.selectedSalesConciergeRequest.emit(this.salesConciergeRequest);


    }

}
